import * as React from 'react'

import { useStripe } from '@stripe/react-stripe-js'

import { observer } from 'mobx-react'

const StripeForm = (props: React.PropsWithChildren<{}>) => {
  const stripe = useStripe()

  return React.cloneElement(React.Children.only(props.children) as React.ReactElement<any>, {
    stripe,
  })
}

export default observer(StripeForm)
